// extracted by mini-css-extract-plugin
export default {"contentWrapper":"MqS9S__contentWrapper","toggleBtnWapper":"rpJ61__toggleBtnWapper","toggleBtn":"jKlko__toggleBtn"};